/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerLeftDownIcon16Regular = forwardRef('ArrowDCornerLeftDownIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9 2.75c-.69 0-1.25.56-1.25 1.25v7.94l3.22-3.22a.75.75 0 1 1 1.06 1.06L8.38 13.432a1.95 1.95 0 0 1-2.758 0L1.97 9.78a.75.75 0 0 1 1.06-1.06l3.22 3.22V4A2.75 2.75 0 0 1 9 1.25h6.25a.75.75 0 0 1 0 1.5H9Z" })));
});
